import { type ElementType } from 'react';
import { Card, CardContent } from '@g17eco/ui-modern/components/ui/card';
import { cn } from '@g17eco/ui-modern/lib/utils';

export interface TypeCardOption {
  value: string;
  label: string;
  description?: string;
  Icon: ElementType;
  iconBg: string;
  iconColor: string;
}

interface TypeCardSelectorProps {
  options: TypeCardOption[];
  value: string;
  onChange: (value: string) => void;
}

export const TypeCardSelector = ({ options, value, onChange }: TypeCardSelectorProps) => (
  <div className='tw:grid tw:gap-2 tw:grid-cols-[repeat(auto-fill,minmax(5.25rem,1fr))]'>
    {options.map((option) => {
      const isSelected = value === option.value;
      return (
        <Card
          key={option.value}
          className={cn(
            'tw:transition-all tw:cursor-pointer tw:w-full tw:min-w-0',
            isSelected
              ? 'tw:border-emerald-500 tw:bg-emerald-50 tw:shadow-sm'
              : 'tw:hover:shadow-sm tw:hover:border-emerald-300'
          )}
          onClick={() => onChange(option.value)}
        >
          <CardContent className='tw:p-2 tw:flex tw:flex-col tw:items-center tw:text-center tw:gap-1.5'>
            <div
              className={cn(
                'tw:rounded-full tw:inline-flex tw:items-center tw:justify-center tw:shrink-0',
                isSelected ? 'tw:bg-emerald-100' : option.iconBg
              )}
              style={{ width: 28, height: 28 }}
            >
              <option.Icon className={cn('tw:size-3.5', isSelected ? 'tw:text-emerald-700' : option.iconColor)} />
            </div>
            <div
              className={cn(
                'tw:text-xs tw:font-medium tw:leading-tight tw:w-full tw:break-words',
                isSelected && 'tw:text-emerald-700'
              )}
            >
              {option.label}
            </div>
            {option.description && (
              <div
                className={cn(
                  'tw:text-[0.6rem] tw:leading-tight tw:w-full tw:break-words tw:text-muted-foreground',
                  isSelected && 'tw:text-emerald-600'
                )}
              >
                {option.description}
              </div>
            )}
          </CardContent>
        </Card>
      );
    })}
  </div>
);
